export const addGtmClickTypeAttributes = (gtmClickType?: string) => {
    return gtmClickType
        ? {
              "data-gtm-click-type": gtmClickType,
          }
        : {};
};
